module.exports = __webpack_public_path__ + "img/question.49555bac.svg";